function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "AAB507BE-2E31-4DFB-803B-0113DA770CA8");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "\\u9875\\u9762-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "3.-Find-Similar-Sequences",
  transform: "translate(-862.000000, -106.000000)",
  fill: "#008E8E"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon_3",
  transform: "translate(862.000000, 106.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.32929293,24.1412953 L24.1412953,2.32929293 C25.4277283,1.04285997 27.5134482,1.04285997 28.7998812,2.32929293 L33.6707071,7.20011884 C34.95714,8.4865518 34.95714,10.5722717 33.6707071,11.8587047 L11.8587047,33.6707071 C10.5722717,34.95714 8.4865518,34.95714 7.20011884,33.6707071 L2.32929293,28.7998812 C1.04285997,27.5134482 1.04285997,25.4277283 2.32929293,24.1412953 Z",
  id: "\\u77E9\\u5F62"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.3292929,28.1412953 L44.1412953,6.32929293 C45.4277283,5.04285997 47.5134482,5.04285997 48.7998812,6.32929293 L53.6707071,11.2001188 C54.95714,12.4865518 54.95714,14.5722717 53.6707071,15.8587047 L31.8587047,37.6707071 C30.5722717,38.95714 28.4865518,38.95714 27.2001188,37.6707071 L22.3292929,32.7998812 C21.04286,31.5134482 21.04286,29.4277283 22.3292929,28.1412953 Z",
  id: "\\u77E9\\u5F62\\u5907\\u4EFD-3"
}))));

const SvgIcStabilityScore = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "56px",
  height: "40px",
  viewBox: "0 0 56 40",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcStabilityScore, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-stability-score.bd070304.svg";
export { ForwardRef as ReactComponent };